import Page from "../Components/Page";


export default function NotFound() {
    return (
        <Page title="404, Page not found."/>
    );
}
